export default __webpack_public_path__ + "static/media/krandomn3.e1afa831.png";